import React, { useEffect, useRef, useState } from "react"
import TabsCustom from "src/components/TabsCustom"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import { ToolBarStyle } from "../../../HumanResource/Work/Task/styled"
import WarehouseEntry from "../SimWarehouse/components/WarehouseEntry"
import WarehouseService from "src/services/WarehouseService"
import SvgIcon from "src/components/SvgIcon"
import { Input, Select, DatePicker, message } from "antd"
import ModalCreate from "../SimWarehouse/Modal/ModalCreate"
import { InputSearchStyle } from "../../Setting/common/styled"
import FilterIn from "../SimWarehouse/components/FilterIn"
import STORAGE from "src/lib/storage"
import ListDeliveryBill from "./components/ListDeliveryBill"
import FilterOut from "./components/FilterOut"
import ModalCreateDeliveryBill from "../../Order/Modal/ModalCreateOrder"

const DeliveryBill = props => {
  const [disableBtn, setDisableBtn] = useState(false)
  const [tab, setTab] = useState("1")
  const [searchTerm, setSearchTerm] = useState("")
  const [filter, setFilter] = useState({})
  const [openModalCreate, setOpenModalCreate] = useState(false)
  const [activeKey, setActiveKey] = useState("all")
  const [tabStatus, setTabStatus] = useState("export")
  const [excelKeyword, setExcelKeyword] = useState("")

  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "export",
    },
    // pending: {
    //   type: "pending",
    //   name: "Chờ duyệt",
    //   status: "1",
    // },
    // success: {
    //   type: "success",
    //   name: "Đã duyệt",
    //   status: "3",
    // },
    received: {
      type: "received",
      name: "Đã tiếp nhận",
      status: "2",
    },
    order_done: {
      type: "order_done",
      name: "Hoàn thành mua",
      status: "3",
    },
    export: {
      type: "export",
      name: "Đã xuất kho",
      status: "4",
    },
    reject: {
      type: "reject",
      name: "Đã hủy",
      status: "6",
    },
  }

  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))
  const handleChangeTab = key => {
    setActiveKey(key)
    setTabStatus(Tabs[key].status)
  }

  const handleExportExcel = async () => {
    try {
      const response = await WarehouseService.getExportOutOfStock({
        // status: filter.status ?? null,
        // sim_type: filter.sim_type ?? null,
        // customer_id: filter.customer_id ?? null,
        // carrier_id: filter.carrier_id ?? null,
        // package_id: filter.package_id ?? null,
        // network_id: filter.network_id ?? null,
        ...filter,
        status: Tabs[activeKey]?.status,
        keyword: excelKeyword,
        order_export_status: 2,
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "Danh_sach_phieu_xuat_kho.xlsx")
        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }

  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("warehouse.export")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }

  return (
    <div>
      <WrapperStyle>
        <ToolBarStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#005F90",
                margin: 0,
              }}
            >
              PHIẾU XUẤT KHO
            </h3>
          </div>
          <div className="right-side">
            {permissions.includes("warehouse.export.export") ? (
              <Button btnType="primary1" onClick={handleExportExcel}>
                Xuất Excel
              </Button>
            ) : (
              <React.Fragment />
            )}
          </div>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <StyleTabsCustom>
              <TabsCustom
                onChange={handleChangeTab}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
                destroyInactiveTabPane={true}
                scroll={{ x: true }}
              />
            </StyleTabsCustom>
            <ListDeliveryBill
              // type={tabStatus}
              scroll={{ x: true }}
              status={tabStatus}
              setFilter={setFilter}
              filter={filter}
              setExcelKeyword={setExcelKeyword}
            />
          </div>
        </ToolBarStyle>
      </WrapperStyle>
      {/* {openModalCreate && (
        <ModalCreateDeliveryBill
          open={openModalCreate}
          onCancel={() => setOpenModalCreate(false)}
          onOk={() => {
            setOpenModalCreate(false)
          }}
        />
      )} */}
    </div>
  )
}

export default DeliveryBill
